import styled from "@emotion/styled";
import { Button, Typography } from "@kaltura/ds-react-components";
import { Container } from "@kaltura/mediaspace-shared-ui";
import { translate, translatePlural } from "@kaltura/mediaspace-shared-utils";

interface NewLinkLineProps {
    linksNumber: number;
    onClick: () => void;
}

const InlineContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
}));

/**
 * Guest Access - new links button and indication
 */
export const NewLinksLine = (props: NewLinkLineProps) => {
    const { linksNumber, onClick } = props;

    return (
        <Container>
            <InlineContainer>
                <Typography variant="body2">
                    {linksNumber > 0
                        ? translatePlural("%1 link", "%1 links", [linksNumber])
                        : translate("No links added")}
                </Typography>
                <Button variant="pill" color="secondary" disabled={linksNumber > 2} onClick={onClick}>
                    {translate("Create new link")}
                </Button>
            </InlineContainer>
        </Container>
    );
};
